import React from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from './ErrorBoundary';

/**
 * Wrapper component that provides error boundary functionality with error handling hooks
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to wrap
 * @param {Function} props.onGoHome - Optional custom go home handler
 * @param {Function} props.onError - Optional custom error handler
 */
const ErrorBoundaryWrapper = ({children, onGoHome}) => {
  const handleGoHome = React.useCallback(() => {
    if (onGoHome) {
      onGoHome();
    } else {
      // Default behavior - handled by ErrorBoundary
    }
  }, [onGoHome]);

  return <ErrorBoundary onGoHome={handleGoHome}>{children}</ErrorBoundary>;
};

ErrorBoundaryWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  onGoHome: PropTypes.func
};

export default React.memo(ErrorBoundaryWrapper);
